import { FontData, FontName } from "@/types/";

interface LoadedFonts {
    [key: FontName]: boolean;
}

const loadedFonts: LoadedFonts = {};

export const loadFontToDocument = async (fontData: FontData) => {
    const key = `${fontData.name}-${fontData.style}-${fontData.weight}`;
    if (!loadedFonts[key]) {
        console.log(fontData.url);
        const font = new FontFace(fontData.name, fontData.url, {
            style: fontData.style,
            weight: String(fontData.weight),
        });
        await font.load();
        document.fonts.add(font);
        loadedFonts[key] = true;
    }
    loadedFonts.logo = await loadedFonts[key];
};
